import Snappy from '../../../libs/snappy/snappy';
import Form from '../../../libs/validation/customValidation.js';

Snappy.Component.FindCourse = class FindCourse extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-find-course';
	}
	
	constructor(element) {
		super(element);
	}
	
	setVars() {
		this.findCourseForm = document.getElementById('findCourseForm');
	}
	
	render() {
		this.setVars();
		this.attachValidationToForm();
	}
	
	attachValidationToForm() {
		this.formInstance = new Form(this.findCourseForm);
		this.formInstance.init();
	}
};



// WEBPACK FOOTER //
// ./components/findCourse/scripts/findCourse.js